// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"b5","message":"b6","header":"b7","subHeading":"b8","buttons":"b9","buttonWrapper":"b-","btn":"b_"};